import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import {addNotification} from "./notifications";

export const GET_SUPPLIERS_REQUEST = 'GET_SUPPLIERS_REQUEST';
export const GET_SUPPLIERS_SUCCESS = 'GET_SUPPLIERS_SUCCESS';
export const GET_SUPPLIERS_ERROR = 'GET_SUPPLIERS_ERROR';

export const GET_SUPPLIER_REQUEST = 'GET_SUPPLIER_REQUEST';
export const GET_SUPPLIER_SUCCESS = 'GET_SUPPLIER_SUCCESS';
export const GET_SUPPLIER_ERROR = 'GET_SUPPLIER_ERROR';

export const CREATE_SUPPLIER_REQUEST = 'CREATE_SUPPLIER_REQUEST';
export const CREATE_SUPPLIER_SUCCESS = 'CREATE_SUPPLIER_SUCCESS';
export const CREATE_SUPPLIER_ERROR = 'CREATE_SUPPLIER_ERROR';

export const UPDATE_SUPPLIER_REQUEST = 'UPDATE_SUPPLIER_REQUEST';
export const UPDATE_SUPPLIER_SUCCESS = 'UPDATE_SUPPLIER_SUCCESS';
export const UPDATE_SUPPLIER_ERROR = 'UPDATE_SUPPLIER_ERROR';

export const CHANGE_STATUS_SUPPLIER_REQUEST = 'CHANGE_STATUS_SUPPLIER_REQUEST';
export const CHANGE_STATUS_SUPPLIER_SUCCESS = 'CHANGE_STATUS_SUPPLIER_SUCCESS';
export const CHANGE_STATUS_SUPPLIER_ERROR = 'CHANGE_STATUS_SUPPLIER_ERROR';

export const DELETE_SUPPLIER_REQUEST = 'DELETE_SUPPLIER_REQUEST';
export const DELETE_SUPPLIER_SUCCESS = 'DELETE_SUPPLIER_SUCCESS';
export const DELETE_SUPPLIER_ERROR = 'DELETE_SUPPLIER_ERROR';

export const CLEAN_SUPPLIERS = 'CLEAN_SUPPLIERS';

// Get suppliers
export function getSuppliers(query) {
    return async (dispatch) => {
        try {
            dispatch(getSuppliersRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/suppliers/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSuppliersSuccess, getSuppliersError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSuppliersError));
        }
    };
};

function getSuppliersRequest() {
    return {
        type: GET_SUPPLIERS_REQUEST,
        isFetching: true
    };
}

function getSuppliersSuccess (payload) {
    return {
        type: GET_SUPPLIERS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getSuppliersError(errorMessage) {
    return {
        type: GET_SUPPLIERS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get supplier
export function getSupplier(supplierId) {

    return async (dispatch) => {
        try {
            dispatch(getSupplierRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/suppliers/${supplierId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSupplierSuccess, getSupplierError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSupplierError));
        }
    };
};

function getSupplierRequest() {
    return {
        type: GET_SUPPLIER_REQUEST,
        isFetching: true
    };
}

function getSupplierSuccess (payload) {
    return {
        type: GET_SUPPLIER_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getSupplierError(errorMessage) {
    return {
        type: GET_SUPPLIER_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create supplier
export function createSupplier(supplier) {
    return async (dispatch) => {
        try {
            dispatch(createSupplierRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/suppliers', supplier, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createSupplierSuccess, createSupplierError));
        } catch (err) {
            dispatch(utilsLib.response(err, createSupplierError));
        }
    };
};

function createSupplierRequest() {
    return {
        type: CREATE_SUPPLIER_REQUEST,
        isFetching: true
    };
}

function createSupplierSuccess (payload) {
    return dispatch => {
        // Create notification for create supplier success
        dispatch(addNotification({
            message: 'Proveedor creado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CREATE_SUPPLIER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function createSupplierError(errorMessage) {
    return dispatch => {
        // Create notification for create supplier error
        dispatch(addNotification({
            message: 'Error al crear el proveedor',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_SUPPLIER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update supplier
export function updateSupplier(supplierId, supplier = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateSupplierRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/suppliers/${supplierId}`, supplier, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateSupplierSuccess, updateSupplierError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateSupplierError));
        }
    };
};

function updateSupplierRequest() {
    return {
        type: UPDATE_SUPPLIER_REQUEST,
        isFetching: true
    };
}

function updateSupplierSuccess (payload) {
    return dispatch => {
        // Create notification for update supplier success
        dispatch(addNotification({
            message: 'Proveedor actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_SUPPLIER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function updateSupplierError(errorMessage) {
    return dispatch => {
        // Create notification for update supplier error
        dispatch(addNotification({
            message: 'Error al actualizar el proveedor',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_SUPPLIER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change supplier status
export function changeSupplierStatus(supplierId, status) {
    return async (dispatch) => {
        try {
            dispatch(changeSupplierStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/suppliers/${supplierId}/status`, { status }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeSupplierStatusSuccess, changeSupplierStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeSupplierStatusError));
        }
    };
};

function changeSupplierStatusRequest() {
    return {
        type: CHANGE_STATUS_SUPPLIER_REQUEST,
        isFetching: true
    };
}

function changeSupplierStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_SUPPLIER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function changeSupplierStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_SUPPLIER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Get customer
export function deleteSupplier(supplierId) {

    return async (dispatch) => {
        try {
            dispatch(deleteSupplierRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/suppliers/${supplierId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteSupplierSuccess, deleteSupplierError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteSupplierError));
        }
    };
}

function deleteSupplierRequest() {
    return {
        type: DELETE_SUPPLIER_REQUEST,
        isFetching: true
    };
}

function deleteSupplierSuccess (payload) {
    return dispatch => {
        // Create notification for delete customer success
        dispatch(addNotification({
            message: 'Proveedor eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_SUPPLIER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function deleteSupplierError(errorMessage) {
    return dispatch => {
        // Create notification for delete customer error
        dispatch(addNotification({
            message: 'Error al eliminar el proveedor',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_SUPPLIER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean suppliers reducer
export function cleanSuppliers() {
    return {
        type: 'CLEAN_SUPPLIERS',
        isFetching: false,
        error: false,
        payload: []
    }
}


// WEBPACK FOOTER //
// ./src/actions/suppliers.js